/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * jeeves/v1/api.proto
 * OpenAPI spec version: version not set
 */

/**
 * A part of an email message.

 - EMAIL_PART_UNSPECIFIED: Unspecified email part. Not returned by the server.
 - EMAIL_PART_SUBJECT: The subject line.
 - EMAIL_PART_HEADERS: The headers other than the subject, such as the sender and recipients.
 - EMAIL_PART_BODY: The message body.
 */
export type V1EmailPart = (typeof V1EmailPart)[keyof typeof V1EmailPart];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1EmailPart = {
  EMAIL_PART_UNSPECIFIED: 'EMAIL_PART_UNSPECIFIED',
  EMAIL_PART_SUBJECT: 'EMAIL_PART_SUBJECT',
  EMAIL_PART_HEADERS: 'EMAIL_PART_HEADERS',
  EMAIL_PART_BODY: 'EMAIL_PART_BODY',
} as const;
